
import React, { useState } from 'react'
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap'

/**
 * BuyerPopover - Hover popup showing buyer/dealer details with address and phone.
 * BRD: "Buyer: List the purchasing dealer (hover over of dealer name/address with phone number)"
 */
const BuyerPopover = ({ 
	id, 
	buyerName, 
	dealerCode,
	address, 
	city, 
	province, 
	postalCode, 
	contactPhone,
	contactEmail,
	children 
}) =>
{
	const [isOpen, setIsOpen] = useState(false)

	const togglePopover = () => setIsOpen(!isOpen)

	const fullAddress = [
		address,
		[city, province].filter(Boolean).join(', '),
		postalCode
	].filter(Boolean).join('\n')

	const hasDetails = fullAddress || contactPhone || contactEmail

	if (!hasDetails)
	{
		return children || <span>{buyerName || '—'}</span>
	}

	return (
		<>
			<span
				id={id}
				style={{ 
					color: '#007bff', 
					cursor: 'pointer', 
					textDecoration: 'underline',
					borderBottom: '1px dotted #007bff'
				}}
				onMouseEnter={() => setIsOpen(true)}
				onMouseLeave={() => setIsOpen(false)}
			>
				{children || buyerName || '—'}
			</span>
			<Popover
				placement="right"
				isOpen={isOpen}
				target={id}
				toggle={togglePopover}
			>
				<PopoverHeader>
					{buyerName || 'Buyer Details'}
					{dealerCode && <span className="text-muted ms-2">({dealerCode})</span>}
				</PopoverHeader>
				<PopoverBody>
					{fullAddress && (
						<div className="mb-2" style={{ whiteSpace: 'pre-line' }}>
							<strong>Address:</strong><br />
							{fullAddress}
						</div>
					)}
					{(contactPhone || contactEmail) && (
						<div>
							<strong>Contact:</strong><br />
							{contactPhone && (
								<>
									<a href={`tel:${contactPhone}`}>{contactPhone}</a>
									<br />
								</>
							)}
							{contactEmail && (
								<a href={`mailto:${contactEmail}`}>{contactEmail}</a>
							)}
						</div>
					)}
				</PopoverBody>
			</Popover>
		</>
	)
}

export default BuyerPopover
